<template>
    <div class="container">

        <div>
            <button type="button" class="btn btn-primary btn-sm m-1" @click="ShowAddCityModal()">
            Add City
            </button>
        </div>

        <span v-if="isDataFetched" class="d-flex justify-content-center">
            <div class="spinner-border text-primary">
                <span class="visually-hidden"></span>
            </div>
             Loading...
        </span>

        <div class="row m-2">
            <table class="table text-left bg-light text-dark table-hover col-12">
                <thead>
                    <tr class="h4 col-12">
                        <td>Name</td>
                        <td>Edit</td>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="city in cities" v-bind:key="city.cityId" @click="showCityModal(city)" class="col-12">
                        <td @click="ShowCityDetailModal(city)">{{city.name}}</td>
                        <td @click="ShowUpdateModal(city)">Edit</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <button type="button" class="btn btn-primary collapse" id="cityDetailModalButton" data-bs-toggle="modal" data-bs-target="#cityDetailModal">
        Launch cityDetailModal
        </button>

        <div class="modal" id="cityDetailModal" tabindex="999999">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title text-align-center text-primary fw-bold" id="cityDetailModalLabel" v-if="!isNewCityToAdd">Detail for City with City-Id = {{selectedCity.cityId}}</h4>
                        <h4 class="modal-title text-align-center text-primary fw-bold" id="cityDetailModalLabel" v-if="isNewCityToAdd">Enter New City Information</h4>

                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">

                        <div class="row p-2 m-2 modal-body text-left">
                            <div class="row">
                                <span class="text-primary col-3">Name </span>
                                <span class="text-primary col-9" v-if="!isEntryMode">{{selectedCity.name}}</span>
                                <input type="text" v-if="isEntryMode" class="text-danger col-9" v-model="selectedCity.name" placeholder="Enter City Name ">
                            </div>
                        </div>

                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                        <button type="button" v-if="!isNewCityToAdd" @click="DeleteCity()" class="btn btn-danger">Delete City</button>
                        <button type="button" v-if="!isNewCityToAdd" @click="UpdateCity()" class="btn btn-secondary" data-bs-dismiss="modal">Update City</button>
                        <button type="button" v-if="isNewCityToAdd" @click="AddCity()" class="btn btn-secondary" data-bs-dismiss="modal">Add City</button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
import { toRaw } from 'vue';

export default({
name:'CitiesView',
props:{
    baseUrl:String
},
data() {
    return {
        cities:[],
        isDataFetched:false,
        selectedCity:{},
        isNewCityToAdd:false,
        isEntryMode:true,
        isModalAlreadyOpened:false
    }
},
methods:{
    getCitiesList(){
        this.isDataFetched = true;
        let citiesRequestUrl = this.baseUrl + "Cities/Cities";
        let citiesRequestOptions = {
            method:"GET",
            headers:{
              "Authorization":"Bearer " + localStorage.token,
              "Content-Type" : "application/json"
            },
          };

          fetch(citiesRequestUrl, citiesRequestOptions)
          .then(response =>{
            return response.json();
          })
          .then(res =>{
            this.cities = res.cities;
            this.isDataFetched = false;
          })
          .catch(error=>{
            error = null;
            console.log("error encountered", error);
            this.isDataFetched = false;
          });
    },
    AddCity(){
        let addCityRequestUrl = this.baseUrl + "Cities/AddCity";
        let addCityRequestOptions = {
            method:"POST",
            headers:{
                "Authorization":`Bearer ${localStorage.token}`,
                "Content-Type":"application/json"
            },
            body:JSON.stringify(
                {
                    "cityId" : 0,
                    "name": this.selectedCity.name
                }
            )
        };

        fetch(addCityRequestUrl, addCityRequestOptions)
        .then(async response=>{
            const result = await response.json();

            if(response.ok){
                alert("City added successfully!");
                await this.getCitiesList();
            }
            else{
                alert("Failed to add city. Please try again.");
                console.error("Add error:", result);
            }
        })
        .catch(error=>{
            console.error("Add failed:", error);
            alert("An error occurred while adding the city.");
        });
    },
    UpdateCity(){
        let updateCityRequestUrl = this.baseUrl + "Cities/UpdateCity";
        let updateCityRequestOptions = {
            method:"POST",
            headers:{
                "Authorization":`Bearer ${localStorage.token}`,
                "Content-Type":"application/json"
            },
            body:JSON.stringify(
                {
                    "cityId" : this.selectedCity.cityId,
                    "name": this.selectedCity.name
                }
            )
        };

        fetch(updateCityRequestUrl, updateCityRequestOptions)
        .then(async response=>{
            const result = await response.json();

            if(response.ok){
                alert("City updated successfully!");
                await this.getCitiesList();
            }
            else{
                alert("Failed to update city. Please try again.");
                console.error("Update error:", result);
            }
        })
        .catch(error=>{
            console.error("Update failed:", error);
            alert("An error occurred while updating the city.");
        });
    },
    DeleteCity(){
        if(!confirm("Delete city '" + this.selectedCity.name + "'?")){
            return;
        }

        let deleteCityRequestUrl = this.baseUrl + "Cities/DeleteCity";
        let deleteCityRequestOptions = {
            method:"POST",
            headers:{
                "Authorization":`Bearer ${localStorage.token}`,
                "Content-Type":"application/json"
            },
            body:JSON.stringify(
                {
                    "Id": this.selectedCity.cityId
                }
            )
        };

        fetch(deleteCityRequestUrl, deleteCityRequestOptions)
        .then(async response=>{
            const result = await response.json();

            if(response.ok){
                alert("City deleted successfully!");
                document.getElementById("cityDetailModalButton").click();
                await this.getCitiesList();
            }
            else{
                alert(result.details || "Failed to delete city. It may still be in use by a company, site, department, or officer.");
                console.error("Delete error:", result);
            }
        })
        .catch(error=>{
            console.error("Delete failed:", error);
            alert("An error occurred while deleting the city.");
        });
    },
    ShowAddCityModal(){
        this.isEntryMode = true;
        this.isNewCityToAdd = true;
        this.selectedCity = {
            cityId : 0,
            name : ""
        };
        document.getElementById("cityDetailModalButton").click();
    },
    ShowCityDetailModal(city){
        this.isNewCityToAdd = false;
        this.isEntryMode = false;

        this.selectedCity = toRaw(city);

        document.getElementById("cityDetailModalButton").click();
    },
    showCityModal(city){
        if(this.isModalAlreadyOpened == false)
        {
            this.selectedCity = toRaw(city);
            document.getElementById("cityDetailModalButton").click();
        }
    },
    ShowUpdateModal(city){
        this.isNewCityToAdd = false;
        this.isEntryMode = true;

        this.selectedCity = toRaw(city);

        document.getElementById("cityDetailModalButton").click();
    }
},
mounted(){
    this.getCitiesList();

    const cityDetailModalEl = document.getElementById('cityDetailModal')
    cityDetailModalEl.addEventListener('shown.bs.modal', event => {
        this.isModalAlreadyOpened = true;
    });
    cityDetailModalEl.addEventListener('hidden.bs.modal', async event => {
        this.isModalAlreadyOpened = false;
        await this.getCitiesList();
    });
},

})
</script>
<style>
</style>
